// extracted by mini-css-extract-plugin
module.exports = {"StyledLink":"StyledLink_StyledLink__AtiaK","IconWrapper":"StyledLink_IconWrapper__Nf_I3","IconTranslate":"StyledLink_IconTranslate__4HChl"};